import email from "../assets/email.png";
import mobile from "../assets/mobile.png";
import banner from "../assets/banner.jpeg";
import Jupyter from "../assets/Jupyter.png";
import python from "../assets/python.png";
import SQL from "../assets/SQL.png";
import GhumGham from "../assets/Ghum-Gham.png";
import movie_reco from "../assets/movie_reco.png";
import emotion_detection from "../assets/emotion_detection.png";  
import Ayuscal_Sedhai_Resume from "../assets/Ayuscal_Sedhai_Resume.pdf";

const images = {
  email,
  mobile,
  banner,
  Jupyter,
  python,
  SQL,
  GhumGham,
  movie_reco,
  emotion_detection,
  Ayuscal_Sedhai_Resume,
};

export default images;
